import { useContext } from 'react'
import { useQuery } from 'react-query'
import { apiGet } from 'api'
import AuthContext from 'context/auth-context'
import UserContext from 'context/user-context'

const getDataAccessUsers = async (token, params) => {
  const url = `data_access/${params.data_access_id}/users`
  const data = await apiGet({ url, params, token })
  return data
}

export function useDataAccessUsers({ params, options }) {
  const token = useContext(AuthContext)
  const { municipality_id } = useContext(UserContext)
  const queryFn = () =>
    getDataAccessUsers(token, { ...params, municipality_id })
  const queryKey = ['data-access-users', params]
  return useQuery(queryKey, queryFn, { ...options })
}
